module.exports = __webpack_public_path__ + "media/images/pic/brodno/savvy-ed-ecc3a4f94a0eae60b0a821e7b90de245.webp";